<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('Profile|Task Templates Feature') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'Profile|Task templates allow you to create reusable task structures with predefined fields, descriptions, and settings. This helps standardize task creation and save time.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Personal Templates') }}</h4>
            <p>
              {{
                s__(
                  'Profile|When enabled, you can create personal task templates that are available to you across all projects. Personal templates are visible only to you.'
                )
              }}
            </p>

            <h4>{{ s__('Profile|Using Templates') }}</h4>
            <p>
              {{
                s__(
                  "Profile|When creating a new task, you can select a template to pre-fill the task with the template's title, description, priority, and other settings. You can then customize the task before saving."
                )
              }}
            </p>

            <h4>{{ s__('Profile|Use Cases') }}</h4>

            <div style="margin-bottom: 16px">
              <strong style="color: #333">{{
                s__('Profile|Example 1: Bug Report Template')
              }}</strong>
              <p style="margin: 4px 0 0 0; color: #666">
                {{
                  s__(
                    'Profile|Create a template for bug reports with predefined fields like "Steps to reproduce", "Expected behavior", and "Actual behavior". This ensures all bug reports follow a consistent format and include essential information.'
                  )
                }}
              </p>
            </div>

            <div style="margin-bottom: 16px">
              <strong style="color: #333">{{
                s__('Profile|Example 2: Code Review Template')
              }}</strong>
              <p style="margin: 4px 0 0 0; color: #666">
                {{
                  s__(
                    'Profile|Set up a template for code review tasks with a standard description format, appropriate priority level, and required labels. This saves time when creating multiple review tasks and maintains consistency across your workflow.'
                  )
                }}
              </p>
            </div>

            <div style="margin-bottom: 16px">
              <strong style="color: #333">{{
                s__('Profile|Example 3: Meeting Follow-up Template')
              }}</strong>
              <p style="margin: 4px 0 0 0; color: #666">
                {{
                  s__(
                    'Profile|Create a template for action items from meetings with a structured description format and due date reminders. This helps you quickly capture and track action items without manually entering the same information each time.'
                  )
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('Profile|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}
</style>
